import moment from "moment";

import {createReport, pdfFileName} from "@/utils/pdfKit";
import {kickOffLabel, matchCompetition, matchTitle} from "@/utils/convocation";

// Matricola FIGC dalla scheda giocatore; gli altri nomi per i dati importati
export const getCardNumber = (player) =>
	player?.serialNumber ||
	player?.cardNumber ||
	player?.registrationNumber ||
	player?.membershipNumber ||
	player?.federationNumber ||
	"";

export const getIdentityDocument = (player) =>
	[player?.identityDocumentType, player?.identityDocumentNumber]
		.filter(Boolean)
		.join(" ");

// Senza staff scelto nella convocazione: righe da compilare a mano
const BLANK_STAFF_ROWS = 5;

const sortByNumber = (list) =>
	[...list].sort(
		(a, b) =>
			parseInt(a.playerNumber || 999, 10) -
				parseInt(b.playerNumber || 999, 10) ||
			`${a.player?.lastName || a.playerName || ""}`.localeCompare(
				`${b.player?.lastName || b.playerName || ""}`,
			),
	);

const playerRow = (p) => [
	p.playerNumber || "",
	`${p.player?.lastName || ""} ${p.player?.firstName || ""}`.trim() ||
		p.playerName ||
		"—",
	p.player?.dateOfBirth
		? moment(p.player.dateOfBirth).format("DD/MM/YYYY")
		: p.playerYear || "",
	getCardNumber(p.player),
	getIdentityDocument(p.player),
];

// Distinta da consegnare all'arbitro: giocatori, staff in panchina, firma
export const generateMatchLineupPDF = (matchData, teamData) => {
	const report = createReport({
		title: "Distinta ufficiale",
		club: teamData?.club || matchData?.homeClub || "Squadra",
		subtitle: [
			matchTitle(matchData),
			matchData?.startDate &&
				moment(matchData.startDate).format("DD/MM/YYYY") +
					" · " +
					kickOffLabel(matchData),
		],
	});
	report.header();
	report.infoCard([
		{label: "Competizione", value: matchCompetition(matchData)},
		{label: "Giornata", value: teamData?.roundLabel || matchData?.round},
		{label: "Campo", value: matchData?.fieldName},
		{label: "Squadra", value: teamData?.club},
	]);

	const columns = [
		{label: "N°", width: 0.6, align: "center", bold: true},
		{label: "Calciatore", width: 4, bold: true},
		{label: "Nascita", width: 1.6},
		{label: "Matricola", width: 1.6},
		{label: "Documento", width: 2.4},
	];
	const players = teamData?.players || [];
	const starters = sortByNumber(
		players.filter((p) => !p.provisional && p.startingPlayer),
	);
	const subs = sortByNumber(
		players.filter((p) => !p.provisional && !p.startingPlayer),
	);
	const partial = sortByNumber(players.filter((p) => p.provisional));

	report.section(`Titolari (${starters.length})`);
	report.table(columns, starters.map(playerRow));
	report.section(`Riserve (${subs.length})`);
	report.table(columns, subs.map(playerRow));
	if (partial.length) {
		report.section(`Presenze da verificare (${partial.length})`);
		report.table(columns, partial.map(playerRow));
	}
	report.section("Staff in panchina");
	report.table(
		[
			{label: "Nome", width: 4.6, bold: true},
			{label: "Ruolo", width: 3},
			{label: "Tessera o documento", width: 2.6},
		],
		teamData?.staff?.length
			? teamData.staff.map((s) => [s.name, s.role, ""])
			: Array.from({length: BLANK_STAFF_ROWS}, () => ["", "", ""]),
	);
	report.signatures(["Il dirigente accompagnatore", "L'allenatore"]);
	report.finish(
		pdfFileName(
			"distinta",
			teamData?.club || "squadra",
			matchData?.startDate && moment(matchData.startDate).format("YYYYMMDD"),
		),
	);
};
